module.exports = __webpack_public_path__ + "static/media/hall-P4.d7603e2b.svg";